import { ReactComponent as ApprovalPendingIcon } from 'assets/images/status/approval-pending.svg'
import { ReactComponent as ApprovedIcon } from 'assets/images/status/approved.svg'
import { ReactComponent as InProgressIcon } from 'assets/images/status/in-progress.svg'
import { ReactComponent as NewIcon } from 'assets/images/status/new.svg'
import { ReactComponent as RejectedIcon } from 'assets/images/status/rejected.svg'
import { ReactComponent as ScrappedIcon } from 'assets/images/status/scrapped.svg'
import { ReactComponent as OnHoldIcon } from 'assets/images/status/on-hold.svg'

export type StatusOption = {
  id:
    | 'new'
    | 'in_progress'
    | 'approval_pending'
    | 'hold'
    | 'approved'
    | 'scrapped'
    | 'rejected'
  icon?: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
  label: string
}

export type ItemOption = {
  id: 'private_doc' | 'assignment'
  label: string
}

export type SortOption = {
  sortOrder: 'asc' | 'desc'
  sortBy: 'last_activity' | 'created_at' | 'client_approval_deadline'
  label: string
}

export const itemOptions: ItemOption[] = [
  {
    id: 'assignment',
    label: 'Orders',
  },
  {
    id: 'private_doc',
    label: 'Internal Docs',
  },
]

export const statusOptions: StatusOption[] = [
  {
    id: 'new',
    icon: NewIcon,
    label: 'New',
  },
  {
    id: 'in_progress',
    icon: InProgressIcon,
    label: 'In Progress',
  },
  {
    id: 'approval_pending',
    icon: ApprovalPendingIcon,
    label: 'Approval Pending',
  },
  {
    id: 'hold',
    icon: OnHoldIcon,
    label: 'On Hold',
  },
  {
    id: 'approved',
    icon: ApprovedIcon,
    label: 'Approved',
  },
  {
    id: 'scrapped',
    icon: ScrappedIcon,
    label: 'Scrapped',
  },
  {
    id: 'rejected',
    icon: RejectedIcon,
    label: 'Rejected',
  },
]

export const sortOptions: SortOption[] = [
  {
    sortOrder: 'desc',
    sortBy: 'last_activity',
    label: 'Date Updated',
  },
  {
    sortOrder: 'desc',
    sortBy: 'created_at',
    label: 'Date Added',
  },
  {
    sortOrder: 'asc',
    sortBy: 'client_approval_deadline',
    label: "'Approval due in' latest first",
  },
  {
    sortOrder: 'desc',
    sortBy: 'client_approval_deadline',
    label: "'Approval due in' earliest first",
  },
]
